<div mat-dialog-title>

  <h1 class="title-dialog">{{'verModMunicipio' | translate}}</h1>

  <span class="example-spacer"></span>

  <mat-icon *appHasPermission="{submoduleId: 31, type: 'isSpecial', key_identity: 'sp_sendNoti'}" color="primary"
    matTooltip="{{ 'notificacionPrueba' | translate }} - telegram" matTooltipClass="colortooltip"
    (click)="sendNotification()">
    send
  </mat-icon>

  <mat-icon color="primary" matTooltip="{{'' | translate}}" id="nombreIn" [ngClass]="{'ocultar': modificar ==='true'}"
    matTooltipClass="colortooltip" (click)="modificarInfo()">
    check
  </mat-icon>

  <mat-icon color="warn" matTooltip="{{'cancelar' | translate}}" [ngClass]="{'ocultar': modificar ==='true'}"
    matTooltipClass="colortooltip" (click)="QuitarModoModificar()">
    close
  </mat-icon>

  <mat-icon color="primary" matTooltip="{{'modificar' | translate}}" [ngClass]="{'ocultar': modificar !=='true'}"
    matTooltipClass="colortooltip" (click)="modoModificar()">
    edit
  </mat-icon>

  <mat-icon color="warn" matTooltip="{{'cerrar' | translate}}" [ngClass]="{'ocultar': modificar !=='true'}"
    [mat-dialog-close]="null" matTooltipClass="colortooltip">
    exit_to_app
  </mat-icon>

</div>

<div mat-dialog-content>

  <div class="containerToggle">
    <mat-slide-toggle color="primary" class="slideAdministrar" [disabled]='modificar'
    [(ngModel)]="data.deteccionesCompartidas">{{'compartirDetecciones' | translate}}</mat-slide-toggle>
    <mat-slide-toggle
      *appHasPermission="{submoduleId: 31, type: 'isDelete'}"
      color="primary"
      class="slideAdministrar"
      [disabled]='modificar'
      [(ngModel)]="data.Eliminado">
      {{'eliminado' | translate}}
    </mat-slide-toggle>
  </div>

  <mat-tab-group class="form-tab-group" [(selectedIndex)]="selectedTabIndex">

    <mat-tab label="Información Básica">
      @if (selectedTabIndex === 0) {
        <div class="container-tab-body">
          <mat-form-field class="mat" appearance="outline">
            <mat-label>{{'Tabla_Nombre' | translate}}</mat-label>
            <input matInput [(ngModel)]="data.Nombre" [disabled]='modificar'>
          </mat-form-field>
          <mat-form-field class="mat" appearance="outline">
            <mat-label>{{'provincia' | translate}}</mat-label>
            <input matInput [(ngModel)]="data.Provincia" [disabled]='modificar'>
          </mat-form-field>
          <mat-form-field class="mat" appearance="outline">
            <mat-label>{{'poblacion' | translate}}</mat-label>
            <input matInput [(ngModel)]="data.Poblacion" [disabled]='modificar'>
          </mat-form-field>
          <mat-form-field class="mat" appearance="outline">
            <mat-label>{{'codigoPostal' | translate}}</mat-label>
            <input matInput [(ngModel)]="data.CodPostal" [disabled]='modificar' maxlength="10">
            <mat-hint align="end">{{ data.CodPostal?.length ?? 0 }} / 10</mat-hint>
          </mat-form-field>
        </div>
      }
    </mat-tab>

    <mat-tab label="Datos de Contacto">
      @if (selectedTabIndex === 1) {
        <div class="container-tab-body">
          <mat-form-field class="mat" appearance="outline">
            <mat-label>{{'correo' | translate}}</mat-label>
            <input matInput [(ngModel)]="data.Email" [disabled]='modificar' [email]="true">
          </mat-form-field>
          <div class="d-flex gap-1">
            <mat-form-field class="mat" appearance="outline">
              <mat-label>{{'contacto' | translate}}</mat-label>
              <input matInput [(ngModel)]="data.Contacto" [disabled]='modificar'>
            </mat-form-field>
            <mat-form-field class="mat" appearance="outline">
              <mat-label>{{'telefono' | translate}}</mat-label>
              <input matInput [(ngModel)]="data.Telefono" [disabled]='modificar'>
            </mat-form-field>
          </div>
          <div class="d-flex gap-1">
            <mat-form-field class="mat" appearance="outline">
              <mat-label>{{'contacto' | translate}} 2</mat-label>
              <input matInput [(ngModel)]="data.Contacto2" [disabled]='modificar'>
            </mat-form-field>
            <mat-form-field class="mat" appearance="outline">
              <mat-label>{{'telefono' | translate}} 2</mat-label>
              <input matInput [(ngModel)]="data.Telefono2" [disabled]='modificar'>
            </mat-form-field>
          </div>
          <div class="d-flex gap-1">
            <mat-form-field class="mat" appearance="outline">
              <mat-label>{{'contacto' | translate}} 3</mat-label>
              <input matInput [(ngModel)]="data.Contacto3" [disabled]='modificar'>
            </mat-form-field>
            <mat-form-field class="mat" appearance="outline">
              <mat-label>{{'telefono' | translate}} 3</mat-label>
              <input matInput [(ngModel)]="data.Telefono3" [disabled]='modificar'>
            </mat-form-field>
          </div>
        </div>
      }
    </mat-tab>

    <mat-tab label="Ubicación">
      @if (selectedTabIndex === 2) {
        <div class="container-tab-body">
          <mat-form-field class="mat" appearance="outline">
            <mat-label>{{'Latitud' | translate}}</mat-label>
            <input matInput [(ngModel)]="data.Latitud" [disabled]='modificar'>
          </mat-form-field>
          <mat-form-field class="mat" appearance="outline">
            <mat-label>{{'Longitud' | translate}}</mat-label>
            <input matInput [(ngModel)]="data.Longitud" [disabled]='modificar'>
          </mat-form-field>
          <mat-form-field class="mat" appearance="outline">
            <mat-label>{{ 'zonaHoraria' | translate }}</mat-label>
            <mat-select [(ngModel)]="data.zona_horaria" [disabled]="modificar">
              <mat-option class="background-white">
                <ngx-mat-select-search [formControl]="searchControl"
                  placeholderLabel="{{'buscar_zonaHoraria' | translate}}"
                matTooltip="{{'paraBuscarIntroduce3Caracteres' | translate}}"></ngx-mat-select-search>
              </mat-option>
              @for (zona of zonaHoraria; track zona) {
                <mat-option [value]="zona.id">
                  {{ zona.descripcion }} ({{ zona.current_utc_offset }})
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </mat-tab>

    <mat-tab label="Otros">
      @if (selectedTabIndex === 3) {
        <div class="container-tab-body">
          <mat-form-field class="mat" appearance="outline">
            <mat-label>{{'idTarifa' | translate}}</mat-label>
            <input matInput type="text" [formControl]="stateCtrlAc" [(ngModel)]="data.IdTarifa">
              <mat-hint align="start">*{{ 'solo_se_aceptan' | translate }} {{ 'numeros' | translate }}</mat-hint>
            </mat-form-field>
            <mat-form-field class="mat" appearance="outline">
              <mat-label>{{'fechaInstalacion' | translate}}</mat-label>
              <input matInput [matDatepicker]="picker" (click)="picker.open()" [formControl]="date">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="mat" appearance="outline">
                <mat-label>{{'fechaInstalacionAcometida' | translate}}</mat-label>
                <input matInput [matDatepicker]="pickerA" (click)="pickerA.open()" [formControl]="date2">
                  <mat-datepicker-toggle matSuffix [for]="pickerA"></mat-datepicker-toggle>
                  <mat-datepicker #pickerA></mat-datepicker>
                </mat-form-field>
              </div>
            }
          </mat-tab>
          @if (permisoSeguridad) {
            <mat-tab label="Seguridad">
              @if (selectedTabIndex === 4) {
                <div class="container-tab-body">
                  <mat-form-field class="mat" appearance="outline">
                    <mat-label>{{ 'clave' | translate }}</mat-label>
                    <input matInput [type]="hidePassword ? 'password' : 'text'" [(ngModel)]="data.Clave"
                      [disabled]="modificar" [readonly]="modificar">
                      <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
                        [attr.aria-label]="'Mostrar/ocultar contraseña'" [disabled]="modificar" type="button">
                        <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                }
              </mat-tab>
            }
          </mat-tab-group>

        </div>